module.exports = __webpack_public_path__ + "static/metrimax-c565f603ffe9f618da81a1792de09935.svg";